module.exports = {"533324101":"茨开镇","533324102":"丙中洛镇","533324202":"捧当乡","533324203":"普拉底乡","533324204":"独龙江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/533324.json
// module id = 2804
// module chunks = 0